var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"live-webcast-indicator",class:_vm.pending ? 'pending' : '',style:(_vm.indicatorVariables)},[(_vm.animate && !_vm.pending)?_c('div',{staticClass:"ping"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }